/*
 * @Descripttion: 
 * @Author: zhanghang
 * @Date: 2023-11-06 11:13:57
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-11-21 17:29:32
 */
export default {
  active:"color",
  color: {
    // 选色方式 默认为空 单色色盘选择 color  线性渐变 linear  径向渐变 radial
    type: "color",
    //提供给渐变使用
    image: "",
    isTheme: false,
    theme: "main",
    value: "rgba(255,255,255,0)",
  }
}